const blur = {
    name: "blur",
    path: "/blur",
    title: "blur",
    description: "Utilities for applying blur filter effects to elements.",
    value: {
        'filter': {
            'blur-xs': 'blur(var(--blur-xs))',
            'blur-sm': 'blur(var(--blur-sm))',
            'blur-md': 'blur(var(--blur-md))',
            'blur-lg': 'blur(var(--blur-lg))',
            'blur-xl': 'blur(var(--blur-xl))',
            'blur-2xl': 'blur(var(--blur-2xl))',
            'blur-3xl': 'blur(var(--blur-3xl))',
            'blur-none': '',
            'blur-[<value>]': 'blur(<value>);',
        },
    },
    exampleData: [
        {
            "title": "blur-sm,blur-lg",
            "description": "to blur an element:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-5 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg blur-none",
                        "text": "blur-none",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg blur-sm",
                        "text": "blur-sm",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg blur-lg",
                        "text": "blur-lg",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg blur-xl",
                        "text": "blur-xl",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg blur-[6px]",
                        "text": "blur-[6px]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="blur-none" src="/img/mountains.jpg" />
<img class="blur-sm" src="/img/mountains.jpg" />
<img class="blur-lg" src="/img/mountains.jpg" />
<img class="blur-2xl" src="/img/mountains.jpg" />
<img class="blur-[6px]" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default blur;